import { OnlinePaymentsSettings } from '../modules/online-payments/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';

export function CompanyOnlinePaymentsSettingsScreen() {
  const { can, company, timeZone } = useCompanyScope();
  // Só estabelecimento atende e cobra cliente; unidade de apoio não tem conta própria (ADR 0039).
  const units = (company.businessUnits ?? []).filter((unit) => unit.kind !== 'SUPPORT');
  return (
    <GatedCompanyScreen allowed={can('online_payments.settings.manage')}>
      <OnlinePaymentsSettings units={units} timeZone={timeZone} />
    </GatedCompanyScreen>
  );
}
